import { ref, onMounted, onBeforeUnmount } from '#imports';
import { debounce } from 'lodash-es';

function calculateProgress(offset) {
  const limit = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  );
  const pageHeight = limit - window.innerHeight - offset;

  return Number((window.pageYOffset / pageHeight) * 100).toFixed(1);
}

export function useCalculateScrollProgress({
  bottomOffset = 0,
  forceHideBottomOffset = 0,
} = {}) {
  const progress = ref(0);
  const forceHideProgress = ref(0);

  function updateProgress() {
    progress.value = calculateProgress(bottomOffset);
    forceHideProgress.value = calculateProgress(forceHideBottomOffset);
  }

  const debouncedUpdateProgress = debounce(updateProgress, 10);

  onMounted(() => {
    window.addEventListener('scroll', debouncedUpdateProgress);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', debouncedUpdateProgress);
  });

  return { progress, forceHideProgress };
}
